module.exports = __webpack_public_path__ + "img/white_bishop.ea87fdb6.png";